<template>
  <Card class="page-add-block">
    <Tooltip
      position="bottom"
      v-bind:show="showTooltip"
      v-on:tooltip-closed="onTooltipClosed"
    >
      <div class="row">
        <div class="col-12 card-action-wrapper">
          <button
            type="button"
            class="card-action-button"
            @click="$root.$emit('show::modal', 'quiz-type-select-modal')"
          >
            <img src="/static/images/ic-edit.svg" class="page-create-icon" />
            <span class="typography--body-2">
              {{ $t('card_details.create_page') }}
            </span>
          </button>
        </div>
        <div class="divider"></div>
        <div class="col-12 card-action-wrapper">
          <button
            type="button"
            class="card-action-button"
            @click="openPageLibraryModal"
          >
            <img src="/static/images/ic-import.svg" class="page-search-icon" />
            <span class="typography--body-2">
              {{ $t('card_details.search_page') }}
            </span>
          </button>
        </div>
      </div>

      <div slot="tooltip-body">
        <div class="typography--body-3 typography--color-secondary"
             v-html="$t('common.tooltip.try_add_new_pages')">
        </div>
      </div>
    </Tooltip>
  </Card>     
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import { isEmpty } from 'lodash';

  export default {
    name: 'page-add-block',

    computed: {
      ...mapGetters([
        'checkedTutorials',
      ]),

      showTooltip() {
        if (!isEmpty(this.checkedTutorials) &&
            !this.checkedTutorials.tryAddNewPages) {
          return true;
        }

        return false;
      },
    },

    methods: {
      ...mapActions([
        'setTutorialAsChecked',
      ]),

      onTooltipClosed() {
        this.setTutorialAsChecked('tryAddNewPages');
      },

      openPageLibraryModal() {
        if (!isEmpty(this.checkedTutorials) &&
            !this.checkedTutorials.tryAddNewPages) {
          return this.setTutorialAsChecked('tryAddNewPages')
            .then(() => {
              this.$root.$emit('show::modal', 'page-library-modal');
            });
        }

        return this.$root.$emit('show::modal', 'page-library-modal');
      },
    },
  };
</script>

<style lang="scss">
  .page-add-block {
    box-shadow: none;
    background-color: transparent;
    transition: border-color 0.2s ease-out;
    background-color: #ffffff;
    height: 200px;
    border-radius: 4px;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);
    border: solid 1px #d9d9d9;

    .page-create-icon,
    .page-search-icon {
      height: 24px;
      width: 24px;
    }

    span {
      font-size: 16px;
      font-weight: bold;
      line-height: 1.5;
      color: rgba(0, 0, 0, 0.87);
    }

    .divider {
      height: 1px;
      background-color: #f0f0f0;
      width: 100%;
    }

    .card-action-wrapper {
      height: 100px;
      text-align: center;
      padding: 20px 0 20px 0;

      .card-action-button {
        width: 380px;
        height: 60px;
        border: none;
        border-radius: 4px;
        cursor: pointer;

        &:hover {
          background-color: #f5f5f5;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/app/my-cards/components/PageAddBlock.vue